<e-dialog-container
  size="md"
  noPadding
  [title]="'platform.appUpdate.title' | transloco"
  [closeLabel]="'platform.appUpdate.later' | transloco"
  (ngClose)="dialogRef.close(false)"
>
  <!-- BELANGRIJK: inhoud in een <ng-template>. e-dialog-container rendert de eerste
       TemplateRef uit zijn content; zonder deze omhulling was dat de verborgen tak van de
       @if hieronder (de chunk-tekst stond dan altijd bovenaan). Zie de dialog-spec. -->
  <ng-template>
    <div class="app-update">
      <section class="app-update__body" data-test-id="app-update-dialog-body">
        <span class="app-update__icon" aria-hidden="true"><i class="fas fa-arrows-rotate"></i></span>
        <div class="app-update__text">
          @if (data.reason === 'chunk') {
            <p class="app-update__message">{{ 'platform.appUpdate.chunkMessage' | transloco }}</p>
          } @else {
            <p class="app-update__message">{{ 'platform.appUpdate.message' | transloco }}</p>
          }
          <p class="app-update__hint">{{ 'platform.appUpdate.unsavedHint' | transloco }}</p>
        </div>
      </section>

      <div class="app-update__version">
        <span class="app-update__label">
          <span class="app-update__dot"></span>{{ 'platform.appUpdate.currentVersion' | transloco }}
        </span>
        <span class="app-update__lead"></span>
        <span class="app-update__value">v{{ data.currentVersion }}</span>
      </div>

      @if (data.newVersion) {
        <div class="app-update__version app-update__version--new" data-test-id="app-update-new-version">
          <span class="app-update__label">
            <span class="app-update__dot"></span>{{ 'platform.appUpdate.newVersion' | transloco }}
          </span>
          <span class="app-update__lead"></span>
          <span class="app-update__value">v{{ data.newVersion }}</span>
        </div>
      }

      <footer class="app-update__footer">
        <button type="button" class="app-update__later" data-test-id="app-update-later" (click)="dialogRef.close(false)">
          {{ 'platform.appUpdate.later' | transloco }}
        </button>
        <button type="button" class="app-update__restart" data-test-id="app-update-restart" (click)="dialogRef.close(true)">
          <i class="fas fa-arrows-rotate" aria-hidden="true"></i>
          <span>{{ 'platform.appUpdate.restart' | transloco }}</span>
        </button>
      </footer>
    </div>
  </ng-template>
</e-dialog-container>
